import { DateTime } from 'luxon';
import { type } from '@mews-framework/utils';
import { ISOFormat } from '../enums';

interface Date {
    value: string;
    timezone: string;
    internal: {
        year: number;
        month: number;
        day: number;
    };
}

function Date(luxon: DateTime): Date {
    return type.create(Date, {
        value: luxon.toFormat(ISOFormat.Date),
        timezone: luxon.zoneName,
        internal: {
            year: luxon.year,
            month: luxon.month,
            day: luxon.day,
        },
    });
}

export default Date;
